import { QueryClient, useQuery } from '@tanstack/react-query';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { StartupCalls } from '../../../../../api/api';
import { RootSettings, UIStartupDto } from '../../../../../api/generated/data-contracts';
import { refactorHelper } from '../../../../../helpers/refactorHelper';
import { OverviewContext } from '../../../../../Utilities/Context/OverviewContext';
import { UserContext } from '../../../../../Utilities/Context/UserContext';
import { useStore } from '../../../../store';
import { upperCaseObj } from '../helpers/queryHelper';
import { UI_SETTINGS_KEY } from '../queryKeys';
import { queryClient } from '../QueryProvider';

export const syncUISettings = (uiStartup: UIStartupDto) => {
    UserContext.Initialize(
        upperCaseObj({ ...uiStartup.user, Resource: uiStartup.resource, IsDelegated: uiStartup.isDelegated, LoginName: uiStartup.loginName }),
    );
    OverviewContext.Settings = refactorHelper.parseSettingsToLegacy(uiStartup.settings);
    document.title = uiStartup.tabTitle;
};

/**
 *
 * @returns cached settings, if any
 */
export const settings = (): RootSettings | undefined => {
    const data = queryClient.getQueryData<UIStartupDto>([UI_SETTINGS_KEY]);
    return data?.settings;
};

export const queryUiSettings = (navigate: NavigateFunction, skibUserCheck?: boolean): Promise<UIStartupDto | null> => {
    return StartupCalls.getUiStartup({})
        .then(res => {
            const data = res.data;
            syncUISettings(data);
            useStore.getState().setUIStartupRefreshed(true); // this is weird but true (ewi)
            if (!data?.resource?.userTypes?.length && !skibUserCheck) {
                navigate('/accessdenied', { replace: true });
            }
            return data;
        })
        .catch(error => {
            console.error(error);
            return null;
        });
};

export const useUISettings = ({ skibUserCheck }: { skibUserCheck?: boolean } = {}, queryClient?: QueryClient) => {
    const navigate = useNavigate();
    return useQuery(
        {
            queryKey: [UI_SETTINGS_KEY],
            queryFn: () => queryUiSettings(navigate, skibUserCheck),

            //
            gcTime: Infinity,
            staleTime: Infinity,
        },
        queryClient,
    );
};
